<!-- 首页 -->
<template>
    <div class="index_wrapper" ref="index">
         <!-- 视频播放区域 -->
        <div class="video_container"
            v-if="video_url">
            <div class="video_wrapper">
                <i class="el-icon-circle-close video_close" @click="bind_close_video"></i>
                <video autoplay class="video_entity" :src="video_url" controls></video>
            </div>
        </div>
        <!-- part1 -->
        <div class="section_item index_section1">
            <div v-show='!isIE9' class="swiper-container banner_slide_wrapper" :style="banner_style">
                <div class="swiper-wrapper banner_wrapper_real">
                    <div v-for="(item, idx) in section1"
                        :key="idx" 
                        class="slide_img swiper-slide">
                        <div class="banner_content">
                            <div class="slide_block" v-if="item.title">
                                <div class="slide_title">{{item.title}}</div>
                                <div class="slide_description">{{item.description}}</div>
                                <el-button type="warning" class="btn_active banner_btn">{{item.btn}}</el-button>    
                            </div> 
                            <img :src="item.link"/>
                        </div>
                    </div>
                </div>
                <div class="swiper-pagination banner_pagination"></div>
            </div>
            <!-- swiper不兼容IE9 -->
            <el-carousel 
                v-show='isIE9'
                class="banner_slide_wrapper_ie9 slide_img"
                height="750px"
                :loop='true'
                :interval="4500">
                <el-carousel-item 
                    v-for="(item, idx) in section1 || []"
                    :key="idx" 
                    class="IE9item">
                    <div class="slide_block" v-if="item.title">
                        <div class="slide_title">{{item.title}}</div>
                        <div class="slide_description">{{item.description}}</div>  
                        <el-button type="warning" class="btn_active" @click="bind_execute_cb(item.cb)">{{item.btn}}</el-button>    
                    </div> 
                    <img :src="item.link"/>
                </el-carousel-item>
            </el-carousel>
            <!-- 文章导向区域 -->
            <div class="articles_wrapper wow" ref="article">
                <div class="articles">
                    <div class="article" 
                        @click="bind_jump_newsContent(item.article_id)"
                        v-for='(item, idx) in news_list'
                        :key="idx">{{item.date}} {{item.title}}</div>
                    <div @click="bind_jump_news" class="more">更多＞</div>
                </div>
            </div>
        </div>
        <div class="articles_wrapper active" v-show="article_active">
            <div class="articles">
                <div class="article" 
                    @click="bind_jump_newsContent(item.article_id)"
                    v-for='(item, idx) in news_list'
                    :key="idx">{{item.date}} {{item.title}}</div>
                <div @click="bind_jump_news" class="more">更多＞</div>
            </div>
        </div>
        <!-- part2 -->
        <div class="section_item index_section2 wow" :class="animation_done?'animated_done': ''">
            <div class="advantage_wrapper">
                <div class="title_wrapper">
                    <div class="title">{{section2.name}}</div>
                    <div class="underline"></div>
                </div>
            </div>
            <div class="lists_wrapper">
                <div v-for="(item, idx) in section2.data || []"
                    :key="idx" 
                    class="list_wrapper"
                    @click="bind_jump_route(item.route)">
                    <img :src="item.link" alt="">
                    <div class="title">{{item.title}}</div>
                    <div class="description">{{item.description}}</div>
                </div>
            </div>
        </div>
        <!-- part3 -->
        <div class="section_item index_section3">
             <div class="case_wrapper">
                <div class="title_wrapper">
                    <div class="title">{{section3.name}}</div>
                    <div class="underline"></div>
                </div>
            </div>
            <div v-show='!isIE9' class="swiper-container case_slide_wrapper">
                <div class="swiper-wrapper banner_wrapper">
                    <div v-for="(item, idx) in case_list_show || []"
                        :key="idx" 
                        class="slide_img swiper-slide">
                        <div class='img_left'>
                            <img class="case_img" :src="item.index_link">
                        </div>
                        <div class="img_right">
                            <div class="img">
                                <div class="case_name">{{item.name}}</div>
                                <div class="tags_wrapper">
                                    <div v-for="(i, idx) in item.tags || []"
                                        class="tag_wrapper">
                                        <div class="tag">{{i.tag}}</div>
                                        <div class="num" :class="item.tags && (idx==(item.tags.length-1)? 'last': '')">{{i.num}}</div>
                                    </div>
                                </div>
                                <div class="description_wrapper">
                                    <el-tag 
                                        v-for="(item, idx) in item.description.split('|')" 
                                        :key="idx"
                                        class="tag_item" type="info">{{item}}</el-tag>
                                </div>
                            </div>
                            <div class="btn_collection">
                                <el-button type="warning" plain class="btn_init" @click="bind_show_case(item)">了解详情</el-button>
                                <el-button type="warning" class="btn_active" @click="bind_toggle_form('cooperation', 'case', item)">申请合作</el-button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="swiper-pagination case_pagination"></div>
            </div>
            <!-- swiper不兼容IE9 -->
            <el-carousel 
                v-show='isIE9'
                class="case_slide_wrapper_ie9 slide_img"
                height="750px"
                :interval="4500"
                :loop='true' >
                <el-carousel-item 
                    v-for="(item, idx) in case_list_show || []"
                    :key="idx" 
                    class="IE9item">
                    <div class='img_left'>
                        <img class="case_img" :src="item.index_link">
                    </div>
                    <div class="img_right">
                        <div class="img">
                            <div class="case_name">{{item.name}}</div>
                            <div class="tags_wrapper">
                                <div v-for="(i, idx) in item.tags || []"
                                    class="tag_wrapper">
                                    <div class="tag">{{i.tag}}</div>
                                    <div class="num" :class="item.tags && (idx==(item.tags.length-1)? 'last': '')">{{i.num}}</div>
                                </div>
                            </div>
                            <div class="description_wrapper">
                                <el-tag 
                                    v-for="(item, idx) in item.description.split('|')" 
                                    :key="idx"
                                    class="tag_item" type="info">{{item}}</el-tag>
                            </div>
                        </div>
                        <div class="btn_collection">
                            <el-button type="warning" plain class="btn_init" @click="bind_show_case(item)">了解详情</el-button>
                            <el-button type="warning" class="btn_active" @click="bind_toggle_form('cooperation', 'case', item)">申请合作</el-button>
                        </div>
                    </div>
                </el-carousel-item>
            </el-carousel>
        </div>

        <!-- part4 -->
        <div class="section_item index_section4">
            <div class="customer_wrapper">
                <div class="title_wrapper">
                    <div class="title">{{section4.name}}</div>
                    <div class="underline"></div>
                </div>
            </div>
            <el-carousel 
                class="customer_slide_wrapper"
                height="426px"
                :interval="4000" 
                type="card"
                arrow='never'>
                <el-carousel-item 
                    v-for="(item, idx) in section4.data || []"
                    :key="idx" 
                    class="item">
                    <img :src="item.link" alt="">
                </el-carousel-item>
            </el-carousel>
        </div>
        <div class="section_item index_section5">
            <div class="form_wrapper">
                <CmsForm/>
            </div>
        </div>
        <BottomMsg/>
    </div>    
</template>

<script>
    import Vue from 'vue';
    import Swiper from 'swiper';
    import CmsForm from '@/components/CmsForm';
    import BottomMsg from '@/components/BottomMsg';
    import data from '@/data/index.js';
    import axios from 'axios';
    import { WOW } from 'wowjs';
    import constant from '@/util/constant';
    import StreamVideoPlayer from '@/components/StreamVideoPlayer';
    export default {
        name: "Index",
        components: {
            CmsForm,
            BottomMsg,
            StreamVideoPlayer
        },
        data() {
            return {
                banner_marginLeft: 0,
                news_list: [],
                case_list_show: [],
                banner_style: {},
                video_url: '',
                animation_done: false,
                article_active: false
            }
        },
        computed: {
            section1() {
                return data && data.section1;
            },
            section2() {
                return data && data.section2;
            },
            section3() {
                return data && data.section3;
            },
            section4() {
                return data && data.section4;
            },
            isIE9() {
                return !('placeholder' in document.createElement('input'));
            }
        },
        beforeRouteEnter(to, from, next) {
            next(vm => {
                // vm.bind_update_scroll();
                // 由于首页可以直接通往案例详情页，所以后退时候需要定位到首页中轮播图的位置
                if (from.path.indexOf('case_content') > -1) {
                    setTimeout(() => {
                        let scrollT = localStorage.getItem('scrollT');
                        window.scrollTo(0, scrollT);
                        localStorage.removeItem('scrollT');
                    }, 500)
                }
            });
        },
        mounted() {
            // window.addEventListener('resize', ()=> {
            //     this.fix_timer && clearTimeout(this.fix_timer);
            //     this.fix_timer = setTimeout(() => {
            //         this.fix_banner_margin();
            //     }, 100)
            // })
            this.bind_detect_animate();
            window.onscroll = this.bind_detect_animate;
            this.$refs.index.focus();
            // 百度统计
            let wow = new WOW(
                {
                    live: false,
                    animateClass: 'animated',
                    offset: 100
                }
            );
            wow.init();
            setTimeout(() => {
                this.animation_done = true;
            }, 2100)
            // 获取新闻列表
            axios.get(`${constant.CMS_ADS}/dsp/ow_news.json`).then((res) => {
                this.news_list = res.data.filter((item) => {
                    return item.article_id;
                }).slice(0, 3);
            })
            // 获取案例列表
            axios.get(`${constant.CMS_ADS}/dsp/ow_case.json?112`).then((res) => {
                this.case_list = res.data;
                // 初始化需要展示的案例
                this.case_list_show = this.case_list.slice(0, 3);
            }).then(() => {
                // 案例轮播图
                let caseSwiper = new Swiper('.case_slide_wrapper', {
                    allowTouchMove: false,
                    autoplay: {
                        disableOnInteraction: false,
                        delay: 4500
                    },
                    // loop: true,
                    pagination: {
                        clickable: true,
                        el: '.case_pagination',
                        bulletClass : 'my-bullet',
                        bulletActiveClass: 'my-bullet-active',
                    }
                })
                // caseSwiper.el.onmouseover = function(){ //鼠标放上暂停轮播
                //     caseSwiper.autoplay.stop();
                // }
                // caseSwiper.el.onmouseleave = function(){
                //     caseSwiper.autoplay.start();
                // }
            })
            this.fix_banner_margin();
        },
        methods: {
            // 检测文章是否应该悬浮在底部
            bind_detect_animate(e) {
                let sHeight = document.documentElement.clientHeight || document.body.clientHeight;
                let sTop = document.documentElement.scrollTop || document.body.scrollTop;
                if (sTop < (758 - sHeight - 20)) {
                    this.article_active = true;
                } else {
                    this.article_active = false;
                }
            },
            // 修正banner的margin让整个banner居中
            fix_banner_margin() {
                let docWidth = document.documentElement.clientWidth || document.body.clientWidth;
                let marginLeft = (docWidth - 1280)/2;
                if (this.mySwiper) {
                    // 销毁原来的swiper对象
                    this.mySwiper.destroy();
                }
                let that = this;
                // banner轮播图
                this.mySwiper = new Swiper('.banner_slide_wrapper', {
                    loop: true,
                    autoplay: {
                        disableOnInteraction: false,
                        delay: 4500
                    },
                    // slidesOffsetBefore : marginLeft,
                    allowTouchMove: false,
                    pagination: {
                        el: '.banner_pagination',
                        clickable: true,
                        bulletClass : 'my-bullet',
                        bulletActiveClass: 'my-bullet-active',
                    },
                    on: {
                        init: function() {
                            // 使用loop属性会导致额外生成的dom元素不绑定事件，所以需要手动处理
                            let btnList = document.querySelectorAll('.banner_slide_wrapper .banner_btn');
                            for (let i = 0; i < btnList.length; i++) {
                                if (i == 0) {
                                    btnList[i].addEventListener('click', function() {
                                        that.bind_execute_cb(that.section1[that.section1.length - 1].cb);
                                    })
                                } else if (i == btnList.length - 1) {
                                    btnList[i].addEventListener('click', function() {
                                        that.bind_execute_cb(that.section1[0].cb);
                                    })
                                } else {
                                    btnList[i].addEventListener('click', function() {
                                        that.bind_execute_cb(that.section1[i-1].cb);
                                    })
                                }
                            }
                        }
                    },
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev',
                    },
                    observer:true,
                    observeParents:true
                })
            },
            // 跳转到平台优势
            bind_jump_route(route) {
                this.$router.push({
                    path: `/${route}`
                });
            },
            // 跳转到新闻详情页
            bind_jump_newsContent(id) {
                this.$router.push({
                    path: `/news_content/${id}`
                });
            },
            // 跳转到新闻页
            bind_jump_news() {
                this.$router.push({
                    path: `/news`
                });
            },
            // 跳转到案例详情页
            bind_show_case(item) {
                // history.pushState({}, {}, '/#/case')
                // 记录这个滚动距离
                let scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
                localStorage.setItem('scrollT', scrollTop);
                window._hmt && window._hmt.push(['_trackEvent', 'case_detail_index', JSON.stringify(item)]);
                this.$router.push({
                    path: `/case_content/${item.name_en}`
                });
            },
            // 显示合作/登录组件
            bind_toggle_form(flag, pos, item) {
                // 百度统计
                if (pos == 'case') {
                    // 如果是从案例入口，记录案例详情
                    window._hmt && window._hmt.push(['_trackEvent', 'ctaTrigger', `index_${pos}`, JSON.stringify(item)]);
                } else {
                    window._hmt && window._hmt.push(['_trackEvent', 'ctaTrigger', `index_${pos}`, flag]);
                }
                this.$emit('toggleForm', flag);
            },
            // 执行轮播图点击回调
            bind_execute_cb(cb) {
                cb && cb(this);
            },
            // 关闭视频播放
            bind_close_video() {
                this.video_url = '';
            }
        }
    }
</script>

<style scoped>
    /* 整个首页的包裹样式 */
    .index_wrapper {
        min-width: 1280px;
        text-align: center;
        overflow: auto;
    }
    /* 第一部分的样式 */
    .index_section1 {
        background: linear-gradient(0deg, #f5f9ff 0%, #fcfdff 100%);
        background: #fcfdff\9\0;
        position: relative;
        overflow: hidden;
    }
    /* 轮播图包裹狂 */
    .index_section1 .banner_slide_wrapper{
        /* width: 3840px; */
        overflow: hidden;
        /* left: 50%; */
        /* transform: translate(-50%, 0) */
    }
    /* 轮播图内容 */
    .banner_slide_wrapper .banner_content {
        width: 1280px;
        display: inline-block;
        position: relative;
    }
    /* ie9下轮播图包裹狂图片 */
    .banner_slide_wrapper_ie9 img {
        width: 1280px;
    }
    /* 背景图 */
    .index_section1 .slide_img{
        height: 100%;
        position: relative;
        text-align: center;
    }
    /* 描述块 */
    .index_section1 .slide_block {
        position: absolute;
        top: 200px;
        left: 40px;
        text-align: left;
    }
    .slide_block .slide_title {
        font-size: 40px;
        font-weight: bold;
        margin-bottom: 20px;
    }
    .slide_block .slide_description {
        font-size: 14px;
        line-height: 20px;
        width: 400px;
        color: #AAAEB7;
        margin-bottom: 60px;
    }
    .banner_pagination {
        bottom: 70px;
    }
    /* 视频播放区域 */
    .video_container {
        z-index: 9999;
        background: rgba(0, 0, 0, 0.9);
        position: fixed;
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
    }
    .video_wrapper {
        position: absolute;
        width: 73%;
        height: 80%;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        -ms-transform: translate(-50%, -50%);
    }
    .video_container .video_entity {
        position: absolute;
        width: 100%;
        height: 100%;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        -ms-transform: translate(-50%, -50%);
    }
    .video_container .video_close {
        position: absolute;
        top: -40px;
        right: -50px;
        font-size: 50px;
        z-index: 1001;
    }
    /* 文章引导包裹狂 */
    .index_section1 .articles_wrapper {
        position: absolute;
        width: 100%;
        height: 56px;
        bottom: 0;
        left: 0;
        z-index: 1000;
        background: #f2f7fd;
    }
    .articles_wrapper.active {
        position: fixed;
        width: 100%;
        bottom: 0;
        left: 50%;
        transform: translateX(-50%);
        -ms-transform: translateX(-50%);
        z-index: 10000;
        background: rgba(24,39,61, 0.1)    
    }
    .articles_wrapper.animated+
    .articles_wrapper .articles {
        width: 1280px;
        height: 100%;
        margin: 0 auto;
    }
    .articles * {
        float: left;
        text-align: left;
        height: 100%;
        font-size: 14px;
        color: #AAAEB7;
        line-height: 56px;
        cursor: pointer;
    }
    .articles *:hover {
        text-decoration: underline;
    }
    .articles .article {
        width: 27%;
        margin-right: 5%;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow:hidden;
    }
    .articles .more {
        width: 4%;
        text-align: center;
    }

     /* 第二部分的样式 */
    .index_section2 {
        background: #fff;
        height: auto;
    }

    /* 标题包裹狂 */
    .index_section2 .advantage_wrapper {
        width: 1280px;
        margin: 0 auto;
        margin-top: 158px;
    }
    /* 列表包裹狂 */
    .index_section2 .lists_wrapper {
        width: 1280px;
        font-size: 0;
        margin: 52px auto 181px auto;
    }
    /* 各个列表项的样式 */
    .lists_wrapper .list_wrapper {
        display: inline-block;
        width: 224px;
        text-align: center;
        margin-right: 105px;
    }
    .lists_wrapper .list_wrapper:nth-child(4n) {
        margin-right: 0;
    }
    /* 延迟展示动画 */
    .index_section2.animated .list_wrapper {
        animation: 0.5s bigger linear forwards;
    }
    .index_section2.animated_done .list_wrapper {
        animation: none !important;
    }
    .list_wrapper:hover {
        transition: 0.2s linear all;
        transform: translateY(-10px);
        -ms-transform: translateY(-10px);
        opacity: 0.8;
        cursor: pointer;
    }
    .index_section2.animated .list_wrapper:nth-child(2) {
        animation-delay: 0.5s;
    }   
    .index_section2.animated .list_wrapper:nth-child(3) {
        animation-delay: 1s;
    }
    .index_section2.animated .list_wrapper:nth-child(4) {
        animation-delay: 1.5s;
    }   
    
    .list_wrapper img {
        height: 224px;
    }
    .list_wrapper .title {
        font-size: 20px;
        color: #18253D;
        line-height: 20px;
        font-weight: bold;
        margin-top: 12px;
        margin-bottom: 16px;
    }
    .list_wrapper .description {
        font-size: 14px;
        color: #A9AEB8;
        letter-spacing: 0;
        line-height: 22px;
    }

    /* 第三部分的样式 */
    .index_section3 {
        background: #FAFCFF;
        height: auto;
    }
    /* 标题包裹狂 */
    .index_section3 .case_wrapper {
        margin-top: 48px;
    }

    /* 轮播图包裹狂 */
    .index_section3 .case_slide_wrapper {
        width: 1280px;
        margin: 32px auto 22px auto;
    }
    .case_slide_wrapper_ie9 {
         width: 1280px;
        margin: 32px auto 22px auto;
    }
    /* 背景图 */
    .index_section3 .slide_img{
        height: 100%;
    }
    .slide_img .img_left {
        position: relative;
        width: 571px;
        height: 597px;
        float: left;
    }
    .img_left .case_img {
        position: absolute;
        top: 0;
        right: 0;
        width: 100%;
        height: 100%;
    }
    .slide_img .img_right {
        margin-left: 96px;
        width: 613px;
        height: 597px;
        float: right;
    }
    .img_right .img {
        position: relative;
        height: 453px;
        background: url("http://shared.ydstatic.com/ead/dynamic/dynamic-template/image/ow_adimg1/case_right.png");
    }
    .img_right .img .case_name {
        position: absolute;
        display: inline-block;
        font-family: PingFangSC-Regular;
        font-size: 24px;
        color: #18253D;
        letter-spacing: 0;
        line-height: 24px;
        left: 0;
        top: 130px;
    }
    /* 标签包裹框 */
    .img_right .img .tags_wrapper {
        position: absolute;
        left: 0;
        top: 210px;
        width: 100%;
        text-align: center;
        
    }
    .tags_wrapper .tag_wrapper:nth-child(1) {
        float: left;
    }
    .tags_wrapper .tag_wrapper:nth-child(3) {
        float: right;
    }
    /* 单独标签包裹框 */
    .tags_wrapper .tag_wrapper {
        display: inline-block;
    }
    /* 文案 */
    .tag_wrapper .tag {
        font-family: PingFangSC-Regular;
        font-size: 14px;
        color: #A9AEB8;
        letter-spacing: 0;
        line-height: 14px;
        text-align: left;
    }
    /* 数字样式 */
    .tag_wrapper .num {
        font-size: 60px;
        color: #18253D;
        line-height: 70px;
        border-right: 1px solid #e6e6e6;
        margin-top: 5px;
        padding-right: 20px;
    }
    .tag_wrapper .num.last {
        border-right: none;
    }
    .img_right .btn_collection {
        float: left;
    }
    /* 具体标签 */
    .img_right .img .description_wrapper {
        position: absolute;
        left: 0;
        top: 356px;
        width: 100%;
        text-align: left;
    }
    /* 标签间距 */
    .description_wrapper .tag_item {
        margin:0 6px 0 0;
    }
     /* 第四部分的样式 */
    .index_section4 {
        background: #fff;
        height: auto;
    }

    /* 标题包裹狂 */
    .index_section4 .customer_wrapper {
        width: 1280px;
        margin: 86px auto 0 auto;
    }
    /* 走马灯包裹框 */
    .index_section4 .customer_slide_wrapper {
        width: 1280px;
        margin: 48px auto 69px auto;
    } 

     /* 第四部分的样式 */
    .index_section5 {
        background: #FAFCFF;
        height: auto;
    }

    /* 标题包裹狂 */
    .index_section5 .form_wrapper {
        width: 1280px;
        margin: 48px auto 54px auto;
    }
</style>





// WEBPACK FOOTER //
// src/containers/Index/Index.vue